import { useEffect } from "react";
import content from "@/pages/public/publicContent.json";

const { siteUrl, siteName } = content;
const OG_IMAGE = `${siteUrl}/og-image.png`;

function upsertMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
  return el;
}

// Gestione head SEO per la parte pubblica: title, description, canonical, OG, Twitter, robots, JSON-LD.
export function Seo({ title, description, path = "/", robots, jsonLd = [], noCanonical = false }) {
  useEffect(() => {
    const prevTitle = document.title;
    const url = `${siteUrl}${path}`;
    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", robots || "index, follow");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:locale", "it_IT");
    upsertMeta("property", "og:site_name", siteName);
    upsertMeta("property", "og:image", OG_IMAGE);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", OG_IMAGE);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (noCanonical) {
      canonical?.remove();
    } else {
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", url);
    }
    const injected = [];
    jsonLd.forEach((obj, i) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo", `ld-${i}`);
      s.textContent = JSON.stringify(obj);
      document.head.appendChild(s);
      injected.push(s);
    });
    return () => {
      document.title = prevTitle;
      injected.forEach((s) => s.remove());
    };
  }, [title, description, path, robots, jsonLd, noCanonical]);
  return null;
}

export function breadcrumbJsonLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem", position: i + 1, name: it.name,
      item: `${siteUrl}${it.path}`,
    })),
  };
}

export function faqJsonLd(faq) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((f) => ({
      "@type": "Question", name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}
